<template>
  <button class="coupon-button">
    <span :class="['button-text', 'hidden-md', 'hidden-sm', { 'button-promo' : type === 'promo', 'button-action': type !== 'promo' }]">
      {{ type === 'promo' ? $t('Показать код') : $t('Получить скидку') }}
    </span>
    <span class="button-fake-promo hidden-md hidden-sm" v-if="promocode">{{ promocode.slice(-10) }}</span>
    <app-icon class="hidden-lg" width="30" height="30"><icon-chevron-right/></app-icon>
  </button>
</template>

<script>
import AppIcon from '../IconBase.vue';
import IconChevronRight from '../icons/IconChevronRight.vue';

export default {
  name: 'shop-coupon-button',

  components: {
    AppIcon,
    IconChevronRight,
  },

  props: {
    type: String,
    promocode: String,
  },

  data() {
    return {};
  }
}
</script>

<style scoped>
.coupon-button {
  position: relative;
  display: inline-block;
  margin: 18px 0 10px 0;
  border: 1px solid #dbdce1;
  border-radius: 3px;
  padding: 0;
  font-size: 16px;
  width: 218px;
  height: 60px;
  line-height: 1;
  cursor: pointer;
  background-color: #fff;
}

.button-text {
  position: absolute;
  top: -1px;
  left: -1px;
  bottom: -1px;
  right: -1px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  min-height: 100%;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
  background-color: #eb3054;
}

.coupon-button:hover .button-text {
  background-color: #b62946;
}

.coupon-button:active .button-text {
  background-color: #2c316b;
}

.button-text.button-promo {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  right: 25px;
}

.button-text.button-promo::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(to left bottom,transparent 50%,#ffb5c4 0,#ffa8b9) 100% 0 no-repeat;
  width: 28px;
  height: 60px;
  transform: translate(1px,4px) rotate(25deg);
  transform-origin: bottom right;
}

.button-fake-promo {
  display: block;
  padding: 0 5px;
  color: #666872;
  font-size: 18px;
  text-align: right;
  text-transform: uppercase;
}

@media (max-width: 1023px) {
  .coupon-button {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto 0;
    border: none;
    width: 50px;
    height: 50px;
    color: #fff;
    background-color: #eb3054;
  }

  .coupon-button:hover {
    background-color: #b62946;
  }

  .coupon-button:active {
    background-color: #2c316b;
  }
}

@media (max-width: 767px) {
  .coupon-button {
    height: 35px;
    width: 35px;
  }
}
</style>